/**
 * Tutor nudger rules (dbo.tblWorkFlowActionsRules) as the System Controls -> Nudger tab edits them: typed
 * fields per rule type, never raw JSON. Which fields a rule has comes from the API's catalogue (fields[]).
 */

export type NudgerRuleFieldKind = 'int' | 'time' | 'provision';

/** The editable parameters. A field the rule type does not use is null. Times are HH:mm. */
export interface NudgerRuleParameters {
  alternativeProvision: string | null;
  minutesSinceSessionStarted: number | null;
  minutesSinceSessionEnded: number | null;
  runTime: string | null;
  endTime: string | null;
  weeksSinceOutCome: number | null;
  weeksSincePlacementEnd: number | null;
  outcomeWithinDaysPlacementEnd: number | null;
}

export type NudgerRuleFieldKey = keyof NudgerRuleParameters;

/** One labelled field of a rule's form. */
export interface NudgerRuleField {
  key: NudgerRuleFieldKey;
  jsonName: string;
  label: string;
  help: string | null;
  kind: NudgerRuleFieldKind | string;
  unit: string | null;
  min: number | null;
  max: number | null;
}

/** One row of GET api/Maintenance/NudgerRules. */
export interface NudgerRule {
  workFlowType: number;
  name: string;
  description: string;
  channel: string;
  isEnabled: boolean;
  parameters: NudgerRuleParameters;
  fields: NudgerRuleField[];
  parametersReadable: boolean;
  updatedBy: string | null;
  updatedUtc: string | null;
}

/** Body of PUT api/Maintenance/NudgerRules/{workFlowType}: the rule's full editable state. */
export interface NudgerRuleUpdateRequest {
  isEnabled: boolean;
  parameters: NudgerRuleParameters;
}

/** One row of GET api/Maintenance/NudgerRules/{workFlowType}/history (latest 50, newest first). */
export interface NudgerRuleHistoryEntry {
  workFlowType: number;
  beforeParameters: string | null;
  afterParameters: string | null;
  beforeEnabled: boolean | null;
  afterEnabled: boolean;
  changedBy: string | null;
  changedUtc: string;
}

/** How a rule's provision value (alternativeProvision) reads on screen. */
export const NUDGER_PROVISION_LABELS: { [value: string]: string } = {
  Y: 'Alternative provision sessions',
  N: 'Other sessions'
};